import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { SubcategoriaProducto } from './subcategoria-producto.model';

@Injectable()
export class SubcategoriaProductoResolver implements Resolve<SubcategoriaProducto> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(SubcategoriaProducto);
      }
      return await this.backendService.get(SubcategoriaProducto, SubcategoriaProducto.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/subcategorias']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/subcategoria-producto/subcategoria-producto.resolver.ts